import React, { useState, useEffect } from 'react';
import BasePage from './BasePage';
import EnergyFlowDiagram from '../components/EnergyFlowDiagram';
import EvChargerCard from '../components/EvChargerCard';
import {
    Typography, Card, Row, Col, Statistic, Tabs, Table,
    Space, Tag, Button, Select, Spin, Drawer, Divider, Empty, message,
} from 'antd';
import {
    DownloadOutlined, LoadingOutlined, CarOutlined,
    ClockCircleOutlined, PlusOutlined, FilterOutlined,
    ThunderboltFilled,
} from '@ant-design/icons';
import { jsPDF } from 'jspdf';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
    AreaChart, Area,
} from 'recharts';
import { analyticsService, equipamentosService, sitesService, cceeService } from '../services/api';
import { useAuth } from '../hooks/useAuth';

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

// ── Ícones SVG inline para os KPI cards ──────────────────────────────────────
const IcoGrid = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="49" viewBox="0 0 31 49" fill="none">
    <path d="M4.40029 32.2761C2.75532 32.1494 0.496355 32.9971 0.482609 29.7926C0.449007 21.1997 0.444425 15.2216 0.467335 11.8614C0.471917 10.7083 0.730041 10.1432 1.28753 9.51999C1.38681 9.40696 1.4647 9.25117 1.52274 9.08164L1.98859 7.63217C2.04357 7.46874 2.1291 7.33434 2.23755 7.25033C2.5644 6.99526 2.97984 6.83947 3.48846 6.78296C3.63355 6.76921 3.70534 6.64855 3.70534 6.4225L3.71909 2.22073C3.7252 1.06757 4.11009 0.500923 4.87988 0.516197H4.9257C5.68175 0.494814 6.06664 1.06757 6.07122 2.23448L6.09871 6.3721C6.09871 6.68979 6.20258 6.84558 6.40724 6.84558H8.80825C8.98543 6.84558 9.13053 6.62564 9.13511 6.35072L9.17177 2.25586C9.18246 1.05994 9.5643 0.473431 10.3112 0.500923H10.3524C11.1085 0.51467 11.4842 1.08132 11.4888 2.19782L11.5025 6.12314C11.5025 6.46985 11.6155 6.67452 11.837 6.72492C12.5258 6.88071 13.0421 7.36183 13.3903 8.16827C13.8211 9.16564 13.9661 9.42682 14.5359 9.97972C14.8535 10.2913 15.0475 10.8289 15.0521 11.4078C15.0842 15.8356 15.0888 21.7847 15.0658 29.2611C15.0613 31.517 14.4182 32.4869 13.1368 32.1753C12.9871 32.1402 12.3258 32.1539 11.1528 32.2318C10.9756 32.2456 10.89 32.3876 10.89 32.6641V34.4114C10.89 34.8574 10.6594 35.2178 10.3738 35.2178H9.28632C9.13205 35.2178 9.00528 35.4088 9.00986 35.6485C9.04194 38.8881 9.06943 40.8187 9.09081 41.4495C9.16718 43.4091 9.83311 44.3851 11.0932 44.3713C14.151 44.3362 19.3562 44.3285 26.7074 44.3637C27.7811 44.3713 28.3249 43.5358 28.3478 41.8603C28.3936 37.8709 28.389 34.7795 28.334 32.5801C28.2928 30.9672 27.7536 30.1821 26.712 30.2249C23.0967 30.3883 21.0821 27.5092 21.0592 22.0413C21.0546 20.7614 21.0546 18.342 21.0638 14.7772C21.0638 14.6 21.1539 14.4595 21.2639 14.4595H23.474C23.6145 14.4595 23.6817 14.5725 23.6771 14.7924C23.613 17.389 23.613 20.0771 23.6725 22.8707C23.7718 27.4405 26.938 25.5374 28.5647 26.7746C30.2356 28.0545 31.0466 30.3043 30.9977 33.5164C30.9305 37.7746 30.9031 40.4842 30.9076 41.6373C30.9168 44.5943 30.1699 46.6104 28.6609 47.6857C27.995 48.1592 26.6814 48.4066 24.7203 48.4219C16.2312 48.4707 11.9057 48.4998 11.7469 48.4998C8.23244 48.5288 6.46986 45.8192 6.4607 40.3788C6.45612 38.7521 6.45154 37.1255 6.44695 35.4912C6.44695 35.201 6.35684 35.088 6.1705 35.1445C5.73062 35.2789 5.30601 35.2652 4.89363 35.0956C4.72562 35.0254 4.64009 34.8482 4.64009 34.5718V32.6687C4.64009 32.4212 4.55913 32.2868 4.40029 32.2792M6.39808 22.5316C6.43015 24.7524 6.43473 26.9731 6.41182 29.2016C6.41182 29.2795 6.42099 29.3497 6.43932 29.4139C6.47139 29.5193 6.50347 29.5773 6.52943 29.591C6.66995 29.6399 6.81046 29.5559 6.88683 29.3711L10.6518 20.013C10.7694 19.7228 10.638 19.3547 10.4211 19.3547H9.08012C8.94419 19.3547 8.83575 19.1851 8.83575 18.9728V12.7977C8.83575 11.5101 8.63261 11.4261 8.21564 12.5426L4.84933 21.6396C4.76838 21.8656 4.86766 22.1421 5.03109 22.1421H6.14606C6.31407 22.1421 6.39502 22.2689 6.39961 22.5316H6.39808Z" fill="#2957A4" />
  </svg>
);
const IcoBateria = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="61" viewBox="0 0 40 61" fill="none">
    <path d="M19.3034 6.13108V2.46316C19.3034 1.50918 19.9534 0.721196 20.7754 0.693197C22.6355 0.629198 24.9556 0.619199 27.7437 0.665198C30.2298 0.711197 29.5498 3.89713 29.6438 6.12908C29.6518 6.45308 29.7938 6.61107 30.0718 6.61907C34.046 6.77707 37.3721 6.39708 39.2002 11.001C39.7382 12.363 40.0083 15.0309 40.0003 19.0028C39.9923 29.1626 39.9763 39.3324 39.9603 49.4942C39.9603 54.3761 39.4782 58.016 35.5901 59.738C34.688 60.1359 33.262 60.3399 31.3139 60.3299C27.3317 60.3119 23.3575 60.3199 19.3814 60.3579C16.1832 60.3859 14.0131 60.0799 12.8731 59.442C10.403 58.072 9.14492 55.588 9.09691 51.9861C9.05691 48.9022 9.04091 45.8082 9.05691 42.7243C9.06491 39.7884 11.061 36.3524 12.6511 34.1745C12.9671 33.7385 13.1191 33.8045 13.1111 34.3785C13.0091 39.8164 12.9771 45.5403 13.0151 51.5321C13.0391 55.292 14.5832 55.848 17.5273 55.876C24.5976 55.95 29.4038 55.988 31.9539 55.988C34.662 55.978 36.0321 54.5241 36.0621 51.6061C36.0701 51.1421 36.0621 38.8524 36.0381 14.7429C36.0301 11.139 33.402 11.047 30.6618 11.019C23.1015 10.945 17.7013 11.029 14.4711 11.269C14.2251 11.287 14.1071 11.149 14.1071 10.861V7.28506C14.1071 6.93307 14.3451 6.65507 14.6452 6.65507H18.8493C19.1493 6.65507 19.3014 6.47908 19.3014 6.12708L19.3034 6.13108Z" fill="#2957A4" />
    <path d="M5.06289 25.625C5.06289 25.337 4.84888 25.097 4.59487 25.097H0.722703C0.168679 25.097 -0.179336 24.393 0.0966759 23.829L11.2452 1.27351C11.3552 1.04152 11.5452 0.875523 11.7592 0.809524C12.4252 0.623528 12.7732 0.939521 12.8192 1.7535C12.8272 1.8655 12.8352 7.20939 12.8512 17.7772C12.8512 18.1192 13.0812 18.3892 13.3733 18.3892H18.1315C18.7015 18.3892 19.0495 19.1291 18.7495 19.7051L6.51695 42.5546C6.40695 42.7586 6.23094 42.9066 6.03493 42.9526C5.42491 43.0906 5.12489 42.7126 5.13289 41.8127C5.13289 41.4507 5.10889 36.0508 5.06089 25.623L5.06289 25.625Z" fill="#6CD84C" />
    <path d="M34.5617 41.8707C34.5617 42.1887 34.3417 42.4467 34.0717 42.4467L14.7209 42.4867C14.4529 42.4867 14.2308 42.2267 14.2288 41.9127L14.2148 33.0769C14.2148 32.7589 14.4349 32.5009 14.7049 32.5009L34.0557 32.4609C34.3237 32.4609 34.5457 32.7209 34.5477 33.0349L34.5617 41.8707Z" fill="#2957A4" />
    <path d="M34.1761 44.4023C34.4841 44.4023 34.7381 44.6983 34.7381 45.0603L34.7461 52.1082C34.7541 53.4601 33.7481 54.5541 32.514 54.5541L16.5373 54.5921C15.3013 54.5921 14.2973 53.5001 14.2893 52.1462L14.2812 45.0983C14.2812 44.7363 14.5353 44.4403 14.8433 44.4403L34.1781 44.4023H34.1761Z" fill="#2957A4" />
  </svg>
);
const IcoSolar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="47" viewBox="0 0 40 47" fill="none">
    <path d="M27.4521 15.4526C27.4521 11.3774 24.1489 8.07422 20.0737 8.07422C15.9985 8.07422 12.6953 11.3774 12.6953 15.4526C12.6953 15.8877 12.741 16.3126 12.8121 16.7274H27.3353C27.4081 16.3126 27.4521 15.8877 27.4521 15.4526Z" fill="#007BFF" />
    <path d="M20.0738 6.10469C20.7697 6.10469 21.3352 5.54091 21.3352 4.84337V2.24961C21.3352 1.55376 20.7714 0.988281 20.0738 0.988281C19.3763 0.988281 18.8125 1.55207 18.8125 2.24961V4.84506C18.8125 5.54091 19.3763 6.10639 20.0738 6.10639V6.10469Z" fill="#007BFF" />
    <path d="M13.6745 6.86593C13.9082 7.27057 14.3314 7.49574 14.7683 7.49574C14.9816 7.49574 15.1983 7.44156 15.3981 7.32644C16.0008 6.97767 16.2074 6.20733 15.8603 5.6046L14.5634 3.35791C14.2146 2.75519 13.4443 2.54694 12.8415 2.89571C12.2388 3.24448 12.0323 4.01482 12.3793 4.61755L13.6762 6.86423L13.6745 6.86593Z" fill="#007BFF" />
    <path d="M7.98941 9.88741L10.2361 11.1843C10.4342 11.2994 10.6509 11.3536 10.8659 11.3536C11.3011 11.3536 11.726 11.1267 11.9597 10.7238C12.3084 10.121 12.1019 9.35071 11.4975 9.00194L9.25075 7.70506C8.64801 7.35459 7.87597 7.56453 7.52889 8.16726C7.18012 8.76999 7.38668 9.54033 7.9911 9.8891L7.98941 9.88741Z" fill="#007BFF" />
    <path d="M6.82384 16.6477H9.41932C10.1152 16.6477 10.6807 16.0839 10.6807 15.3863C10.6807 14.6888 10.1169 14.125 9.41932 14.125H6.82384C6.12799 14.125 5.5625 14.6888 5.5625 15.3863C5.5625 16.0839 6.12629 16.6477 6.82384 16.6477Z" fill="#007BFF" />
    <path d="M29.3555 15.4957C29.3555 16.1915 29.9193 16.757 30.6168 16.757H33.2123C33.9081 16.757 34.4736 16.1932 34.4736 15.4957C34.4736 14.7982 33.9098 14.2344 33.2123 14.2344H30.6168C29.921 14.2344 29.3555 14.7982 29.3555 15.4957Z" fill="#007BFF" />
    <path d="M29.2253 11.4522C29.4386 11.4522 29.6553 11.398 29.8551 11.2829L32.1018 9.986C32.7045 9.63723 32.9111 8.86689 32.564 8.26416C32.2152 7.66144 31.4449 7.45319 30.8422 7.80196L28.5954 9.09884C27.9927 9.44761 27.7862 10.218 28.1332 10.8207C28.3669 11.2253 28.7902 11.4505 29.227 11.4505L29.2253 11.4522Z" fill="#007BFF" />
    <path d="M24.7316 7.38334C24.9297 7.49847 25.1464 7.55264 25.3614 7.55264C25.7965 7.55264 26.2215 7.32577 26.4551 6.92283L27.752 4.67614C28.1008 4.07341 27.8943 3.30307 27.2898 2.9543C26.6871 2.60553 25.9151 2.81378 25.568 3.41651L24.2711 5.66319C23.9223 6.26592 24.1289 7.03626 24.7333 7.38503L24.7316 7.38334Z" fill="#007BFF" />
    <path d="M26.4636 36.772L24.9127 29.2734H15.1877L13.5742 36.772H18.4875V42.9906H14.9879C14.6781 42.9906 14.4275 43.2411 14.4275 43.551V45.4557C14.4275 45.7655 14.6781 46.0161 14.9879 46.0161H25.0126C25.3224 46.0161 25.573 45.7655 25.573 45.4557V43.551C25.573 43.2411 25.3224 42.9906 25.0126 42.9906H21.513V36.772H26.4636Z" fill="#2957A4" />
    <path d="M31.8173 19.7838C31.648 19.4588 31.3127 19.2539 30.947 19.2539H25.4141L26.9649 26.7524H35.4337L31.8173 19.7821V19.7838Z" fill="#2957A4" />
    <path d="M15.7305 26.7524H24.3905L22.8397 19.2539H17.3423L15.7305 26.7524Z" fill="#2957A4" />
    <path d="M39.89 35.3397L36.7426 29.2734H27.4883L29.0391 36.772H39.0198C39.7563 36.772 40.2286 35.9915 39.89 35.3397Z" fill="#2957A4" />
    <path d="M0.111428 35.3397C-0.227187 35.9932 0.246873 36.772 0.981667 36.772H10.9945L12.608 29.2734H3.25716L0.111428 35.3397Z" fill="#2957A4" />
    <path d="M9.05135 19.2539C8.68565 19.2539 8.34873 19.4588 8.18112 19.7838L4.56641 26.7541H13.152L14.7655 19.2556H9.05305L9.05135 19.2539Z" fill="#2957A4" />
  </svg>
);
const IcoCO2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="33" viewBox="0 0 54 33" fill="none">
    <path d="M48.8265 15.2567C47.6523 10.4398 43.5355 6.88275 38.6373 6.88275C37.228 6.88275 35.8835 7.17719 34.6551 7.7114C31.9646 3.36735 27.3359 0.5 22.0776 0.5C15.7829 0.5 10.3911 4.60854 8.14534 10.4407C3.5418 11.6355 0.125 16.049 0.125 21.3109C0.125 27.4904 4.83744 32.5 10.6503 32.5C10.7039 32.5 10.7572 32.4995 10.8108 32.4987H45.4204C45.4677 32.4995 45.5152 32.5 45.5627 32.5C50.2227 32.5 54.0003 28.4842 54.0003 23.5305C54.0003 19.8069 51.8657 16.6133 48.8267 15.2567H48.8265Z" fill="#2957A4" />
    <path d="M11.9065 18.6137C11.9065 15.7082 14.4507 13.2695 17.4615 13.2695C19.0722 13.2695 20.5475 13.9619 21.5711 15.0458L19.6893 16.7168C19.1472 16.0394 18.3345 15.6029 17.4612 15.6029C15.8806 15.6029 14.5408 16.9879 14.5408 18.6137C14.5408 20.2394 15.8806 21.6394 17.4612 21.6394C18.3495 21.6394 19.1472 21.2029 19.7043 20.5255L21.5709 22.1815C20.5473 23.2804 19.0719 23.973 17.4612 23.973C14.4505 23.973 11.9062 21.5191 11.9062 18.6139L11.9065 18.6137Z" fill="white" />
    <path d="M22.2344 18.6137C22.2344 15.7082 24.7786 13.2695 27.7894 13.2695C30.8001 13.2695 33.3594 15.7082 33.3594 18.6137C33.3594 21.5191 30.8151 23.9728 27.7894 23.9728C24.7636 23.9728 22.2344 21.5189 22.2344 18.6137ZM30.7098 18.6137C30.7098 16.9877 29.37 15.6029 27.7894 15.6029C26.2087 15.6029 24.8689 16.9879 24.8689 18.6137C24.8689 20.2394 26.2087 21.6394 27.7894 21.6394C29.37 21.6394 30.7098 20.2544 30.7098 18.6137Z" fill="white" />
    <path d="M35.061 25.4394L37.7726 23.4111C38.5945 22.7919 38.8294 22.3861 38.8294 21.9377C38.8294 21.436 38.3917 21.1158 37.858 21.1158C37.1747 21.1158 36.6623 21.4468 36.1072 22.0338L34.9648 20.9022C35.7442 19.9629 36.6943 19.4609 37.9005 19.4609C39.5446 19.4609 40.6975 20.4644 40.6975 21.8629C40.6975 22.8343 40.2919 23.5923 39.0109 24.4676L37.858 25.2895H40.7724V26.9229H35.061V25.439V25.4394Z" fill="white" />
  </svg>
);
const IcoPreco = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="47" viewBox="0 0 40 47" fill="none">
    <path d="M27.4521 15.4526C27.4521 11.3774 24.1489 8.07422 20.0737 8.07422C15.9985 8.07422 12.6953 11.3774 12.6953 15.4526C12.6953 15.8877 12.741 16.3126 12.8121 16.7274H27.3353C27.4081 16.3126 27.4521 15.8877 27.4521 15.4526Z" fill="#007BFF" />
    <path d="M20.0738 6.10469C20.7697 6.10469 21.3352 5.54091 21.3352 4.84337V2.24961C21.3352 1.55376 20.7714 0.988281 20.0738 0.988281C19.3763 0.988281 18.8125 1.55207 18.8125 2.24961V4.84506C18.8125 5.54091 19.3763 6.10639 20.0738 6.10639V6.10469Z" fill="#007BFF" />
    <path d="M13.6745 6.86593C13.9082 7.27057 14.3314 7.49574 14.7683 7.49574C14.9816 7.49574 15.1983 7.44156 15.3981 7.32644C16.0008 6.97767 16.2074 6.20733 15.8603 5.6046L14.5634 3.35791C14.2146 2.75519 13.4443 2.54694 12.8415 2.89571C12.2388 3.24448 12.0323 4.01482 12.3793 4.61755L13.6762 6.86423L13.6745 6.86593Z" fill="#007BFF" />
    <path d="M7.98941 9.88741L10.2361 11.1843C10.4342 11.2994 10.6509 11.3536 10.8659 11.3536C11.3011 11.3536 11.726 11.1267 11.9597 10.7238C12.3084 10.121 12.1019 9.35071 11.4975 9.00194L9.25075 7.70506C8.64801 7.35459 7.87597 7.56453 7.52889 8.16726C7.18012 8.76999 7.38668 9.54033 7.9911 9.8891L7.98941 9.88741Z" fill="#007BFF" />
    <path d="M6.82384 16.6477H9.41932C10.1152 16.6477 10.6807 16.0839 10.6807 15.3863C10.6807 14.6888 10.1169 14.125 9.41932 14.125H6.82384C6.12799 14.125 5.5625 14.6888 5.5625 15.3863C5.5625 16.0839 6.12629 16.6477 6.82384 16.6477Z" fill="#007BFF" />
    <path d="M29.3555 15.4957C29.3555 16.1915 29.9193 16.757 30.6168 16.757H33.2123C33.9081 16.757 34.4736 16.1932 34.4736 15.4957C34.4736 14.7982 33.9098 14.2344 33.2123 14.2344H30.6168C29.921 14.2344 29.3555 14.7982 29.3555 15.4957Z" fill="#007BFF" />
    <path d="M29.2253 11.4522C29.4386 11.4522 29.6553 11.398 29.8551 11.2829L32.1018 9.986C32.7045 9.63723 32.9111 8.86689 32.564 8.26416C32.2152 7.66144 31.4449 7.45319 30.8422 7.80196L28.5954 9.09884C27.9927 9.44761 27.7862 10.218 28.1332 10.8207C28.3669 11.2253 28.7902 11.4505 29.227 11.4505L29.2253 11.4522Z" fill="#007BFF" />
    <path d="M24.7316 7.38334C24.9297 7.49847 25.1464 7.55264 25.3614 7.55264C25.7965 7.55264 26.2215 7.32577 26.4551 6.92283L27.752 4.67614C28.1008 4.07341 27.8943 3.30307 27.2898 2.9543C26.6871 2.60553 25.9151 2.81378 25.568 3.41651L24.2711 5.66319C23.9223 6.26592 24.1289 7.03626 24.7333 7.38503L24.7316 7.38334Z" fill="#007BFF" />
    <path d="M26.4636 36.772L24.9127 29.2734H15.1877L13.5742 36.772H18.4875V42.9906H14.9879C14.6781 42.9906 14.4275 43.2411 14.4275 43.551V45.4557C14.4275 45.7655 14.6781 46.0161 14.9879 46.0161H25.0126C25.3224 46.0161 25.573 45.7655 25.573 45.4557V43.551C25.573 43.2411 25.3224 42.9906 25.0126 42.9906H21.513V36.772H26.4636Z" fill="#2957A4" />
    <path d="M31.8173 19.7838C31.648 19.4588 31.3127 19.2539 30.947 19.2539H25.4141L26.9649 26.7524H35.4337L31.8173 19.7821V19.7838Z" fill="#2957A4" />
    <path d="M15.7305 26.7524H24.3905L22.8397 19.2539H17.3423L15.7305 26.7524Z" fill="#2957A4" />
    <path d="M39.89 35.3397L36.7426 29.2734H27.4883L29.0391 36.772H39.0198C39.7563 36.772 40.2286 35.9915 39.89 35.3397Z" fill="#2957A4" />
    <path d="M0.111428 35.3397C-0.227187 35.9932 0.246873 36.772 0.981667 36.772H10.9945L12.608 29.2734H3.25716L0.111428 35.3397Z" fill="#2957A4" />
    <path d="M9.05135 19.2539C8.68565 19.2539 8.34873 19.4588 8.18112 19.7838L4.56641 26.7541H13.152L14.7655 19.2556H9.05305L9.05135 19.2539Z" fill="#2957A4" />
  </svg>
);
const IcoCusto = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="34" viewBox="0 0 26 34" fill="none">
    <path d="M24.0257 12.9277H16.8943L18.734 2.28016C19.0183 0.63902 16.3089 -0.177571 15.1415 1.19579L0.340016 18.6358C-0.543056 19.6751 0.39688 21.0723 1.9757 21.0723H9.10718L7.26744 31.7198C6.98312 33.361 9.69255 34.1776 10.8599 32.8042L25.6614 15.3642C26.5411 14.3249 25.6046 12.9277 24.0257 12.9277Z" fill="#2957A4" />
  </svg>
);
const IcoEconomia = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="49" viewBox="0 0 41 49" fill="none">
    <path d="M35.7278 32.6308C35.4699 32.8887 35.1938 33.1285 34.9104 33.3428C32.6072 33.8151 29.3959 34.4817 27.9119 34.7923C27.7793 34.3037 27.5377 33.8405 27.218 33.4409C26.595 32.6762 25.7068 32.204 24.7459 32.124L16.307 31.1723C14.1636 27.8737 14.3235 23.6851 14.3416 23.489C14.3507 23.2583 14.5378 23.0803 14.7594 23.0712C14.9992 23.053 20.5391 22.8405 23.9104 26.2008C24.6932 26.9928 25.2708 27.8901 25.7158 28.8146V20.6445H27.4941V28.8146C27.9391 27.8901 28.5167 26.991 29.3087 26.2008C32.6708 22.8387 38.2108 23.053 38.4506 23.0712C38.6812 23.0803 38.8592 23.2583 38.8683 23.489C38.8865 23.7197 39.099 29.2687 35.7296 32.6308H35.7278Z" fill="#007BFF" />
    <path d="M10.5837 45.5233C10.6763 45.5233 10.7708 45.5378 10.8616 45.5669L18.9554 48.2243C20.4866 48.7274 22.1504 48.533 23.5218 47.6866L39.7712 37.5476C40.614 37.0063 40.6776 36.0109 40.3761 35.3171C39.9456 34.3271 38.7304 34.3562 37.7859 34.556C36.7106 34.783 29.8265 36.2107 27.9302 36.6031C27.8158 37.0681 27.6087 37.5058 27.3144 37.9C27.3017 37.9163 27.289 37.9327 27.2763 37.9472C26.5588 38.8754 25.4327 39.3967 24.2647 39.3621L15.9402 38.8263C15.4498 38.7954 15.0774 38.3722 15.1101 37.8818C15.141 37.3914 15.5715 37.0354 16.0546 37.0517L24.3537 37.5857C24.935 37.6093 25.518 37.3278 25.8849 36.8374C25.894 36.8247 25.9049 36.8119 25.9158 36.7992C26.1429 36.4832 26.2591 36.1108 26.2537 35.7203C26.2482 35.2898 26.1065 34.892 25.8413 34.5669C25.5217 34.1764 25.0712 33.9384 24.5717 33.8948L14.8086 32.7905C13.0195 32.627 11.1831 33.0811 9.6555 34.0619L0.410078 39.9888C0.204826 40.1196 0.0667808 40.3248 0.0177383 40.5628C-0.0294878 40.8007 0.0177383 41.0423 0.1576 41.2421L4.65498 47.772C4.91654 48.1498 5.41605 48.266 5.81929 48.0444L10.1532 45.6359C10.2876 45.5614 10.4365 45.5233 10.5855 45.5233H10.5837Z" fill="#2957A4" />
    <path d="M26.5991 0.5C20.6196 0.5 15.7734 5.34792 15.7734 11.3256C15.7734 17.3033 20.6196 22.1512 26.5991 22.1512C32.5787 22.1512 37.4248 17.3051 37.4248 11.3256C37.4248 5.3461 32.5787 0.5 26.5991 0.5ZM26.1196 10.2921H27.0677C29.0313 10.2921 30.6115 11.985 30.4172 13.9848C30.2682 15.4924 29.0785 16.6458 27.6272 16.9328V18.2805C27.6272 18.4295 27.5055 18.5512 27.3566 18.5512H25.8399C25.6909 18.5512 25.5601 18.4295 25.5601 18.2805V16.951C24.0725 16.7003 22.91 15.4724 22.7793 13.9467C22.7611 13.7886 22.9009 13.6488 23.059 13.6488H24.5757C24.7064 13.6488 24.8263 13.7323 24.8445 13.8631C24.9462 14.477 25.4784 14.942 26.1196 14.942H26.9933C27.6454 14.942 28.2393 14.5043 28.3429 13.8722C28.4827 13.0639 27.8597 12.3555 27.0677 12.3555H26.2776C24.5194 12.3555 22.9464 11.0804 22.7793 9.33305C22.6031 7.52757 23.8673 5.97457 25.5601 5.69485V4.37434C25.5601 4.21631 25.6909 4.09462 25.8399 4.09462H27.3566C27.5055 4.09462 27.6272 4.21631 27.6272 4.37434V5.69485C29.1257 5.94551 30.2882 7.1752 30.4172 8.71004C30.4262 8.86806 30.2955 8.99884 30.1374 8.99884H28.6117C28.4918 8.99884 28.3701 8.91529 28.3519 8.79359C28.2484 8.17965 27.7107 7.70558 27.0677 7.70558H26.1941C25.5529 7.70558 24.9571 8.14333 24.8445 8.78451C24.7137 9.59461 25.3385 10.2921 26.1196 10.2921Z" fill="#007BFF" />
  </svg>
);
const IcoReducao = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="49" viewBox="0 0 41 49" fill="none">
    <path d="M41.0027 41.4116L33.9514 48.503L26.2227 41.4116H28.6389V26.2734H38.0511V41.4116H41.0027Z" fill="#2957A4" />
    <path d="M19.6443 0.5C9.1572 0.5 0.65625 9.05081 0.65625 19.5983C0.65625 30.1464 9.15781 38.6966 19.6443 38.6966C22.4095 38.6966 25.0368 38.1016 27.4063 37.0328V25.04H37.8504C38.3592 23.3153 38.6324 21.4891 38.6324 19.5983C38.6324 9.05081 30.1315 0.5 19.6443 0.5ZM14.9244 33.6197L19.1779 22.1536H8.61758L20.4178 5.57807L15.8978 18.372H30.6711L14.9244 33.6197Z" fill="#2957A4" />
  </svg>
);
const IcoEV       = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><rect x="2" y="8" width="16" height="10" rx="2" fill="#FB8500"/><path d="M18 12h2a2 2 0 0 1 0 4h-2"/><path d="M6 18v2M12 18v2"/><path d="M9 8V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M9 13h2m2 0h2" stroke="white" strokeWidth="1.5" strokeLinecap="round"/></svg>;

// ── Helpers ──────────────────────────────────────────────────────────────────
const fmtKwh  = v => `${(parseFloat(v) || 0).toFixed(2)} kWh`;
const fmtKw   = v => `${(parseFloat(v) || 0).toFixed(2)} kW`;
const fmtBrl  = v => `R$ ${(parseFloat(v) || 0).toFixed(2)}`;
const fmtPct  = v => `${(parseFloat(v) || 0).toFixed(1)}%`;

const formatDuration = (minutes) => {
    if (!minutes || minutes <= 0) return '—';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return h === 0 ? `${m}min` : `${h}h ${m.toString().padStart(2, '0')}min`;
};
const formatDatetime = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
};

// Mini gráfico de energia mensal (para cards de carregadores)
const buildMonthlyChart = (sessions) => {
    const map = {};
    (sessions || []).forEach(s => {
        if (!s.startTime) return;
        const d = new Date(s.startTime);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        const label = d.toLocaleString('pt-BR', { month: 'short', year: '2-digit' });
        if (!map[key]) map[key] = { label, grid: 0, solar: 0, battery: 0 };
        // distribuição estimada (sem dados por fonte, usamos total)
        const kwh = parseFloat(s.energyKwh) || 0;
        map[key].solar   += kwh * 0.6;
        map[key].grid    += kwh * 0.3;
        map[key].battery += kwh * 0.1;
    });
    return Object.entries(map).sort(([a], [b]) => a.localeCompare(b)).map(([, v]) => v);
};

// ── Card KPI ──────────────────────────────────────────────────────────────────
function KpiCard({ title, value, subtitle, Icon, color = '#1890ff', sparkData }) {
    return (
        <Card
            size="small"
            style={{ borderRadius: 8, border: '1px solid #f0f0f0', height: 110 }}
            bodyStyle={{ padding: '14px 16px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                    <div style={{ color, fontWeight: 700, fontSize: 13, marginBottom: 4 }}>{title}</div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#1d1d1d', lineHeight: 1.2 }}>{value}</div>
                </div>
                <div style={{ marginLeft: 8, opacity: 0.85, width: 44, height: 54, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'visible' }}>
                    <div style={{ transform: 'scale(0.72)', transformOrigin: 'center center' }}>
                        <Icon />
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
                <Text type="secondary" style={{ fontSize: 11 }}>{subtitle}</Text>
                {sparkData && sparkData.length > 1 && (
                    <ResponsiveContainer width={60} height={22}>
                        <AreaChart data={sparkData} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                            <Area type="monotone" dataKey="v" stroke={color} fill={`${color}22`} dot={false} strokeWidth={1.5} />
                        </AreaChart>
                    </ResponsiveContainer>
                )}
            </div>
        </Card>
    );
}

// ── Card de Carregador ────────────────────────────────────────────────────────
function ChargerCard({ name, energyKwh, cost, durationMin, chartData }) {
    return (
        <Card
            size="small"
            style={{ borderRadius: 10, border: '1px solid #f0f0f0', marginBottom: 16 }}
            bodyStyle={{ padding: '14px 16px' }}
        >
            <Row align="middle" gutter={16}>
                {/* Ícone + nome + stats */}
                <Col flex="200px">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                        <div style={{
                            width: 44, height: 44, borderRadius: 8,
                            background: '#FFF3E0', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <IcoEV />
                        </div>
                        <Text strong style={{ fontSize: 14 }}>{name}</Text>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>Energia consumida</Text>
                            <Text strong style={{ fontSize: 12, color: '#1890ff' }}>{fmtKwh(energyKwh)}</Text>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>Preço de energia</Text>
                            <Text strong style={{ fontSize: 12, color: '#52c41a' }}>{fmtBrl(cost)}</Text>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>Tempo de recarga</Text>
                            <Text strong style={{ fontSize: 12 }}>{formatDuration(durationMin)}</Text>
                        </div>
                    </div>
                </Col>
                {/* Mini gráfico */}
                <Col flex="1">
                    {chartData && chartData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={80}>
                            <BarChart data={chartData} margin={{ top: 0, right: 0, left: -30, bottom: 0 }}>
                                <XAxis dataKey="label" tick={{ fontSize: 9 }} />
                                <YAxis tick={{ fontSize: 9 }} />
                                <Tooltip formatter={(v, n) => [`${v.toFixed(1)} kWh`, n]} />
                                <Bar dataKey="grid"    name="Energia da Rede"  stackId="a" fill="#1890ff" />
                                <Bar dataKey="solar"   name="Energia Fotovoltaica" stackId="a" fill="#FB8500" />
                                <Bar dataKey="battery" name="Energia da bateria"   stackId="a" fill="#ff4d4f" />
                            </BarChart>
                        </ResponsiveContainer>
                    ) : (
                        <div style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Sem histórico disponível</Text>
                        </div>
                    )}
                </Col>
            </Row>
        </Card>
    );
}

// ── Página principal ──────────────────────────────────────────────────────────
const AnalisesPage = () => {
    const { user } = useAuth();

    const [loading, setLoading]               = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState('month');
    const [selectedSite, setSelectedSite]     = useState('all');
    const [sites, setSites]                   = useState([]);
    const [energyData, setEnergyData]         = useState(null);
    const [energyFlowData, setEnergyFlowData] = useState({});
    const [chargingStations, setChargingStations] = useState([]);
    const [erEquipamentos, setErEquipamentos] = useState([]);
    const [sitesLoaded, setSitesLoaded]       = useState(false);

    // EV Sessions
    const [evSessions, setEvSessions]         = useState([]);
    const [evSessionsTotal, setEvSessionsTotal] = useState({});
    const [evSessionsLoading, setEvSessionsLoading] = useState(false);
    const [evSessionsPeriod, setEvSessionsPeriod]   = useState('month');

    // Drawer carregador
    const [chargerDrawer, setChargerDrawer]   = useState(false);
    const [selectedCharger, setSelectedCharger] = useState(null);

    // ── Carregamento ────────────────────────────────────────────────────────
    useEffect(() => {
        const init = async () => { await fetchSites(); setSitesLoaded(true); };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (sitesLoaded) fetchAllData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedPeriod, selectedSite, sitesLoaded]);

    const fetchSites = async () => {
        try {
            const res = await sitesService.getAllWithRealtime(user?.empresaClienteId || null);
            if (res.success) setSites(res.data);
        } catch (e) { console.error(e); }
    };

    const fetchAllData = async () => {
        setLoading(true);
        try {
            await Promise.all([
                fetchAnalytics(), fetchEnergyFlow(),
                fetchChargingStations(), fetchErEquipamentos(),
                fetchEvSessions(evSessionsPeriod),
            ]);
        } catch (e) { message.error('Erro ao carregar dados'); }
        finally { setLoading(false); }
    };

    const fetchAnalytics = async () => {
        try {
            const siteId = selectedSite !== 'all' ? selectedSite : null;
            const data = await analyticsService.getOverview(selectedPeriod, siteId);
            setEnergyData(data);
        } catch (e) { console.error(e); }
    };

    const fetchEnergyFlow = async () => {
        try {
            const siteId = selectedSite !== 'all' ? selectedSite : null;
            const data = await analyticsService.getEnergyFlowRealtime(siteId);
            setEnergyFlowData(data);
        } catch (e) { console.error(e); }
    };

    const fetchChargingStations = async () => {
        try {
            const siteId = selectedSite !== 'all' ? selectedSite : null;
            const data = await analyticsService.getChargingStations(selectedPeriod, siteId);
            setChargingStations(data.stations || []);
        } catch (e) { console.error(e); }
    };

    const fetchErEquipamentos = async () => {
        try {
            const siteId = selectedSite !== 'all' ? selectedSite : null;
            const data = await analyticsService.getEvChargerLatest(siteId);
            setErEquipamentos(Array.isArray(data?.chargers) ? data.chargers : []);
        } catch (e) {
            try {
                const fb = await equipamentosService.getByType('ESTACAO_RECARGA');
                setErEquipamentos(Array.isArray(fb) ? fb : (fb?.data || []));
            } catch (_) {}
        }
    };

    const fetchEvSessions = async (period = evSessionsPeriod) => {
        setEvSessionsLoading(true);
        try {
            const siteId = selectedSite !== 'all' ? selectedSite : null;
            const end = new Date().toISOString();
            const days = period === '7d' ? 7 : period === 'month' ? 30 : 90;
            const start = new Date(Date.now() - days * 86400000).toISOString();
            const data = await analyticsService.getEvSessions(siteId, start, end);
            setEvSessions(data?.sessions || []);
            setEvSessionsTotal({ total: data?.totalSessions, energy: data?.totalEnergy, autonomy: data?.totalAutonomy });
        } catch (e) { console.error(e); }
        finally { setEvSessionsLoading(false); }
    };

    // ── Helpers de estado ────────────────────────────────────────────────────
    const periodLabel = { today: 'Hoje', week: 'Últimos 7 dias', month: 'Últimos 30 dias' }[selectedPeriod] || '';
    const siteLabel = selectedSite === 'all' ? '(Tudo)' : (sites.find(s => String(s.id) === String(selectedSite))?.name || '—');

    const ed  = energyData;
    const efd = energyFlowData;

    // Dados para o sparkline da "Redução"
    const reductionSpark = ed ? [
        { v: ed.financial.reduction * 0.6 }, { v: ed.financial.reduction * 0.75 },
        { v: ed.financial.reduction * 0.9 }, { v: ed.financial.reduction },
        { v: ed.financial.reduction * 0.95 },
    ] : [];

    // 8 KPI cards
    const kpiCards = [
        { title: 'Grid',         value: ed ? fmtKwh(ed.energy.grid)                 : '0 kWh',  subtitle: 'Consumido da rede',       Icon: IcoGrid,     color: '#1890ff' },
        { title: 'Bateria',      value: ed ? fmtKwh(ed.energy.battery)              : '0 kWh',  subtitle: 'Energia da bateria',      Icon: IcoBateria,  color: '#1890ff' },
        { title: 'Solar (UFV)',  value: ed ? fmtKwh(ed.energy.solar)                : '0 kWh',  subtitle: 'Gerado no período',       Icon: IcoSolar,    color: '#1890ff' },
        { title: 'CO2 Evitado',  value: ed ? `${ed.environmental.co2Avoided} kg`    : '0 kg',   subtitle: 'CO₂',                     Icon: IcoCO2,      color: '#13c2c2' },
        { title: 'Preço Solar',  value: ed ? fmtBrl(ed.financial.solarCost)         : 'R$ 0,00', subtitle: 'Energia Fotovoltaica',    Icon: IcoPreco,    color: '#1890ff' },
        { title: 'Custo',        value: ed ? fmtBrl(ed.financial.gridCost)          : 'R$ 0,00', subtitle: 'Custo da rede',           Icon: IcoCusto,    color: '#1890ff' },
        { title: 'Economia',     value: ed ? fmtBrl(ed.financial.totalSavings)      : 'R$ 0,00', subtitle: 'Valor',                   Icon: IcoEconomia, color: '#1890ff' },
        { title: 'Redução',      value: ed ? fmtPct(ed.financial.reduction)         : '0%',      subtitle: 'Autossuficiência',        Icon: IcoReducao,  color: '#1890ff', sparkData: reductionSpark },
    ];

    // Carregadores com dados agregados
    const erFiltrados = selectedSite === 'all'
        ? erEquipamentos
        : erEquipamentos.filter(er => String(er.siteId) === String(selectedSite));

    const chargerCards = erFiltrados.map(er => {
        const station = chargingStations.find(s => s.name === er.name || String(s.id) === String(er.id));
        // sessões deste carregador (aproximado por nome)
        const mySessions = evSessions.filter(s =>
            s.usinaName === er.siteName || !s.usinaName
        );
        return {
            er,
            totalEnergy: parseFloat(station?.totalEnergy || 0),
            totalCost: parseFloat(station?.totalCost || 0),
            totalMinutes: mySessions.reduce((s, x) => s + (parseInt(x.durationMin) || 0), 0),
            chartData: buildMonthlyChart(mySessions),
        };
    });

    // Distribuição para o Pie
    const pieSources = ed ? [
        { name: 'Solar',   value: ed.energy.solar,   fill: '#FB8500' },
        { name: 'Bateria', value: ed.energy.battery, fill: '#1890ff' },
        { name: 'Grid',    value: ed.energy.grid,    fill: '#722ed1' },
    ].filter(x => x.value > 0) : [];

    // ── Export PDF ────────────────────────────────────────────────────────────
    const handleExportPdf = () => {
        if (!ed) { message.warning('Aguarde os dados carregarem.'); return; }
        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const pageW = doc.internal.pageSize.getWidth();
        const m = 15;
        doc.setFillColor(251,133,0);
        doc.rect(0, 0, pageW, 18, 'F');
        doc.setTextColor(255,255,255); doc.setFontSize(13); doc.setFont('helvetica','bold');
        doc.text('Análise de Consumo — Heliosfera Energias', m, 12);
        let y = 26;
        doc.setTextColor(60,60,60); doc.setFontSize(9); doc.setFont('helvetica','normal');
        doc.text(`Período: ${periodLabel}  |  Site: ${siteLabel}  |  Gerado: ${new Date().toLocaleString('pt-BR')}`, m, y);
        y += 12;
        const row = (l, v) => { doc.setFont('helvetica','bold'); doc.text(l+':', m+2, y); doc.setFont('helvetica','normal'); doc.text(String(v), m+65, y); y += 7; };
        doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.setTextColor(251,133,0);
        doc.text('INDICADORES', m, y); y += 7;
        doc.setTextColor(40,40,40); doc.setFontSize(9);
        row('Solar (UFV)', fmtKwh(ed.energy.solar));
        row('Bateria', fmtKwh(ed.energy.battery));
        row('Grid', fmtKwh(ed.energy.grid));
        row('CO₂ Evitado', `${ed.environmental.co2Avoided} kg`);
        row('Preço Solar', fmtBrl(ed.financial.solarCost));
        row('Custo Grid', fmtBrl(ed.financial.gridCost));
        row('Economia Total', fmtBrl(ed.financial.totalSavings));
        row('Redução', fmtPct(ed.financial.reduction));
        doc.save(`Analise_Consumo_${new Date().toISOString().slice(0,10)}.pdf`);
        message.success('Relatório PDF gerado!');
    };

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <BasePage>
            <div style={{ background: '#fff', padding: '24px 28px', borderRadius: 12 }}>

                {/* ── Cabeçalho ── */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <Title level={3} style={{ margin: 0 }}>Análise de Consumo</Title>
                    <Button
                        icon={<DownloadOutlined />}
                        onClick={handleExportPdf}
                        disabled={!ed}
                    >
                        Criar relatório
                    </Button>
                </div>

                {/* ── 8 KPI Cards ── */}
                <Row gutter={[12, 12]} style={{ marginBottom: 24 }}>
                    {kpiCards.map(kpi => (
                        <Col xs={12} sm={6} key={kpi.title}>
                            <KpiCard {...kpi} />
                        </Col>
                    ))}
                </Row>

                {/* ── Filtros inline ── */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
                    <FilterOutlined style={{ color: '#8c8c8c' }} />
                    <Text type="secondary" style={{ fontSize: 13 }}>Filtros:</Text>
                    <Select
                        value={selectedPeriod}
                        onChange={setSelectedPeriod}
                        size="small"
                        style={{ width: 150 }}
                    >
                        <Option value="today">Hoje</Option>
                        <Option value="week">Últimos 7 dias</Option>
                        <Option value="month">Mês passado</Option>
                    </Select>
                    <Select
                        value={selectedSite}
                        onChange={setSelectedSite}
                        size="small"
                        style={{ width: 200 }}
                        showSearch
                        filterOption={(inp, opt) => opt.children?.toLowerCase().includes(inp.toLowerCase())}
                    >
                        <Option value="all">(Tudo)</Option>
                        {sites.map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                    </Select>
                    {loading && <Spin size="small" indicator={<LoadingOutlined spin />} />}
                </div>

                {/* ── Tabs ── */}
                <Tabs defaultActiveKey="geral" size="middle">

                    {/* ════════ ABA GERAL ════════ */}
                    <TabPane tab="Geral" key="geral">
                        {'solar' in efd ? (
                            <EnergyFlowDiagram data={efd} />
                        ) : (
                            <Empty description="Selecione um site para ver o fluxo de energia" style={{ padding: 60 }} />
                        )}
                    </TabPane>

                    {/* ════════ ABA CARREGADORES ════════ */}
                    <TabPane tab="Carregadores" key="carregadores">
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: 60 }}>
                                <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 40, color: '#FB8500' }} spin />} />
                            </div>
                        ) : chargerCards.length === 0 ? (
                            <Empty
                                image={<CarOutlined style={{ fontSize: 56, color: '#d9d9d9' }} />}
                                description="Nenhuma estação de recarga cadastrada"
                                style={{ padding: 60 }}
                            />
                        ) : (
                            <>
                                {/* KPIs resumo */}
                                {chargingStations.length > 0 && (
                                    <Row gutter={[12, 12]} style={{ marginBottom: 20 }}>
                                        <Col xs={24} sm={8}>
                                            <Card size="small" style={{ borderTop: '4px solid #1890ff', textAlign: 'center', borderRadius: 8 }}>
                                                <Statistic title="Total de Sessões" value={chargingStations.reduce((s,c) => s+(c.sessions||0),0)} valueStyle={{ color: '#1890ff' }} />
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Card size="small" style={{ borderTop: '4px solid #52c41a', textAlign: 'center', borderRadius: 8 }}>
                                                <Statistic title="Energia Total" value={chargingStations.reduce((s,c) => s+(parseFloat(c.totalEnergy)||0),0).toFixed(2)} suffix="kWh" valueStyle={{ color: '#52c41a' }} />
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Card size="small" style={{ borderTop: '4px solid #722ed1', textAlign: 'center', borderRadius: 8 }}>
                                                <Statistic title="Custo Total" value={chargingStations.reduce((s,c) => s+(parseFloat(c.totalCost)||0),0).toFixed(2)} prefix="R$" valueStyle={{ color: '#722ed1' }} />
                                            </Card>
                                        </Col>
                                    </Row>
                                )}

                                {/* Cards individuais */}
                                {chargerCards.map(({ er, totalEnergy, totalCost, totalMinutes, chartData }) => (
                                    <ChargerCard
                                        key={er.id}
                                        name={er.name || `Carregador ${er.id}`}
                                        energyKwh={totalEnergy}
                                        cost={totalCost}
                                        durationMin={totalMinutes}
                                        chartData={chartData}
                                    />
                                ))}

                                {/* Legenda */}
                                <div style={{ display: 'flex', gap: 20, marginTop: 8, flexWrap: 'wrap' }}>
                                    {[
                                        { color: '#1890ff', label: 'Energia da Rede elétrica' },
                                        { color: '#FB8500', label: 'Energia Fotovoltaica' },
                                        { color: '#ff4d4f', label: 'Energia da bateria' },
                                    ].map(l => (
                                        <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                            <div style={{ width: 14, height: 14, background: l.color, borderRadius: 2 }} />
                                            <Text style={{ fontSize: 12 }}>{l.label}</Text>
                                        </div>
                                    ))}
                                </div>

                                <Divider />

                                {/* Histórico de sessões */}
                                <Card
                                    style={{ marginBottom: 8 }}
                                    title={<Space><ClockCircleOutlined style={{ color: '#FB8500' }} /><span>Histórico de Sessões</span></Space>}
                                    extra={
                                        <Select value={evSessionsPeriod} size="small" style={{ width: 140 }}
                                            onChange={v => { setEvSessionsPeriod(v); fetchEvSessions(v); }}>
                                            <Option value="7d">Últimos 7 dias</Option>
                                            <Option value="month">Últimos 30 dias</Option>
                                            <Option value="3months">Últimos 90 dias</Option>
                                        </Select>
                                    }
                                >
                                    <Table
                                        loading={evSessionsLoading}
                                        dataSource={evSessions}
                                        rowKey="id"
                                        size="small"
                                        pagination={{ pageSize: 10, showTotal: t => `${t} sessões` }}
                                        locale={{ emptyText: <Empty description="Nenhuma sessão encontrada" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                                        columns={[
                                            { title: 'Início', dataIndex: 'startTime', width: 130, render: v => formatDatetime(v) },
                                            { title: 'Fim',    dataIndex: 'endTime',   width: 130, render: (v, r) => r.inProgress ? <Tag color="processing">Em curso</Tag> : formatDatetime(v) },
                                            { title: 'Duração', dataIndex: 'durationMin', width: 100, align: 'center', render: v => <Tag icon={<ClockCircleOutlined />}>{formatDuration(v)}</Tag> },
                                            { title: 'Energia', dataIndex: 'energyKwh', width: 110, align: 'right', sorter: (a,b) => a.energyKwh-b.energyKwh, render: v => <Text strong style={{ color: '#52c41a' }}>{Number(v).toFixed(2)} kWh</Text> },
                                            { title: 'Autonomia', dataIndex: 'autonomyKm', width: 110, align: 'right', render: v => <Text style={{ color: '#FA8C16' }}>{Number(v).toFixed(1)} km</Text> },
                                            { title: 'Usina', dataIndex: 'usinaName', render: v => <Text type="secondary" style={{ fontSize: 12 }}>{v}</Text> },
                                        ]}
                                    />
                                </Card>
                            </>
                        )}
                    </TabPane>

                    {/* ════════ ABA GRÁFICOS ════════ */}
                    <TabPane tab="Gráficos" key="graficos">
                        {!ed ? (
                            <Empty description="Sem dados para o período selecionado" style={{ padding: 60 }} />
                        ) : (
                            <Row gutter={[16, 24]}>
                                {/* Distribuição por fonte */}
                                {pieSources.length > 0 && (
                                    <Col xs={24} md={12}>
                                        <Card title="Distribuição de Energia" size="small" style={{ borderRadius: 8 }}>
                                            <ResponsiveContainer width="100%" height={260}>
                                                <PieChart>
                                                    <Pie data={pieSources} cx="50%" cy="50%" outerRadius={90} innerRadius={45} dataKey="value"
                                                        label={e => `${e.name}: ${e.value.toFixed(1)} kWh`} labelLine={false}>
                                                        {pieSources.map((e, i) => <Cell key={i} fill={e.fill} />)}
                                                    </Pie>
                                                    <Tooltip formatter={(v, n) => [`${v.toFixed(2)} kWh`, n]} />
                                                    <Legend />
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </Card>
                                    </Col>
                                )}
                                {/* KPIs financeiros */}
                                <Col xs={24} md={12}>
                                    <Card title="Resumo Financeiro" size="small" style={{ borderRadius: 8, height: '100%' }}>
                                        <Space direction="vertical" style={{ width: '100%' }} size={16}>
                                            <Statistic title="Valor da Energia Solar" value={ed.financial.solarCost} prefix="R$" precision={2} valueStyle={{ color: '#52c41a', fontSize: 22 }} />
                                            <Statistic title="Custo da Rede" value={ed.financial.gridCost} prefix="R$" precision={2} valueStyle={{ color: '#ff4d4f', fontSize: 22 }} />
                                            <Statistic title="Economia Total" value={ed.financial.totalSavings} prefix="R$" precision={2} valueStyle={{ color: '#1890ff', fontSize: 26, fontWeight: 700 }} />
                                            <Statistic title="Redução de Grid" value={ed.financial.reduction} suffix="%" precision={1} valueStyle={{ color: '#52c41a', fontSize: 22 }} />
                                        </Space>
                                    </Card>
                                </Col>
                                {/* Comparativo estações */}
                                {chargingStations.length > 0 && (
                                    <Col xs={24}>
                                        <Card title="Comparativo por Estação de Recarga" size="small" style={{ borderRadius: 8 }}>
                                            <ResponsiveContainer width="100%" height={260}>
                                                <BarChart data={chargingStations}>
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Legend />
                                                    <Bar dataKey="totalEnergy" name="Energia (kWh)" fill="#52c41a" radius={[4,4,0,0]} />
                                                    <Bar dataKey="sessions"    name="Sessões"       fill="#1890ff" radius={[4,4,0,0]} />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                        )}
                    </TabPane>
                </Tabs>
            </div>

            {/* ── Drawer detalhe carregador ── */}
            <Drawer
                title={<Space><CarOutlined style={{ color: '#FB8500' }} /><span>{selectedCharger?.name || 'Estação de Recarga'}</span></Space>}
                open={chargerDrawer}
                onClose={() => setChargerDrawer(false)}
                width={420}
            >
                {selectedCharger && (
                    <div>
                        <Card size="small" style={{ background: '#fafafa', marginBottom: 16 }}>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <div><Text type="secondary">Site</Text><br /><Text strong>{selectedCharger.siteName}</Text></div>
                                <div><Text type="secondary">Fabricante / Modelo</Text><br /><Text strong>{selectedCharger.manufacturer || '—'} {selectedCharger.model || ''}</Text></div>
                                <div><Text type="secondary">Nº de Série</Text><br /><Text>{selectedCharger.serialNumber || '—'}</Text></div>
                                <div><Text type="secondary">Potência Máx.</Text><br /><Text strong>{selectedCharger.potenciaKw ? `${selectedCharger.potenciaKw} kW` : '—'}</Text></div>
                            </Space>
                        </Card>
                        <Tag color={selectedCharger.status === 'CONECTADO' ? 'green' : 'orange'} style={{ fontSize: 13, padding: '4px 12px' }}>
                            {selectedCharger.status || 'Desconhecido'}
                        </Tag>
                    </div>
                )}
            </Drawer>
        </BasePage>
    );
};

export default AnalisesPage;
